var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.event)?_c('ul',{staticClass:"CreationSteps u-flex"},_vm._l((_vm.eventCreationSteps),function(step){return _c('router-link',{key:step.label,class:{
      'current-view': step.label === _vm.selected,
      disabled: _vm.stepsAreDisabled(step.routeName),
    },attrs:{"to":{ name: _vm.event.type === 'dynamic' ? `${step.routeName}-dynamic-form` : step.routeName, params: { id: _vm.id } }}},[(_vm.getIsComplete(step))?_c('span',{staticClass:"Icon-s Icon-check-circle"}):_vm._e(),_vm._v("\n    "+_vm._s(step.label)+"\n  ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }